import React from "react";
import { Navigate } from "react-router-dom";

import PrivateLayout from "../layouts/private/Private";
import useCheckAuthStatus from "../providers/useCheckAuthStatus";
import useCheckUserPermission from "../providers/useCheckUserPermission";

let isLoggedIn = localStorage.getItem("token");

const PrivateRoute = (props) => {
	const { component: Component, moduleCode, moduleName, ...rest } = props;

	useCheckAuthStatus();

	const { dataPermissions, refetchPermissions } = useCheckUserPermission(
		moduleName,
		moduleCode
	);

	if (isLoggedIn) {
		return (
			<PrivateLayout
				dataPermissions={dataPermissions ? dataPermissions.data : []}
				refetchPermissions={refetchPermissions}
				moduleCode={moduleCode}
				moduleName={moduleName}
				{...rest}
			>
				<Component
					dataPermissions={dataPermissions ? dataPermissions.data : []}
					refetchPermissions={refetchPermissions}
					moduleCode={moduleCode}
					moduleName={moduleName}
					{...rest}
				/>
			</PrivateLayout>
		);
	} else {
		return <Navigate to="/" />;
	}
};

export default PrivateRoute;
